
export class DestinacaoReservaCompletoModel {

    constructor(
        public cdCentrus?: string,
        public cdCentrusTit?: string,
        public dsParcela?: string,
        public dsPagamento?: string,
        public vlPagamento?: number,
        public vlPagamentoAnt?: number,
        public vlPagamentoDif?: number,
        public dsAdvogado?: string,
        public vlAdvogado?: number,
        public vlAdvogadoAnt?: number,
        public vlAdvogadoDif?: number,
        public dsImposto?: string,
        public vlImposto?: number,
        public vlImpostoAnt?: number,
        public vlImpostoDif?: number,
        public dsLiquido?: string,
        public vlLiquido?: number,
        public vlLiquidoAnt?: number,
        public vlLiquidoDif?: number,
        public dsMensagem?: string,
        public dsBanco?: string,
        public dsAgencia?: string,
        public dsConta?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/destinacao-reserva-completo.model.ts